module.exports = __webpack_public_path__ + "img/auto.271259d4.png";